import React, { useState } from 'react'

const DEFAULT_AVATAR = '/bnb-profile-default.png'

const COUNTRY_CODES = {
    'united states': 'us', 'usa': 'us', 'canada': 'ca', 'mexico': 'mx',
    'united kingdom': 'gb', 'england': 'gb', 'scotland': 'gb', 'wales': 'gb', 'ireland': 'ie',
    'france': 'fr', 'germany': 'de', 'italy': 'it', 'spain': 'es', 'portugal': 'pt',
    'netherlands': 'nl', 'belgium': 'be', 'switzerland': 'ch', 'austria': 'at', 'denmark': 'dk',
    'sweden': 'se', 'norway': 'no', 'finland': 'fi', 'greece': 'gr', 'turkey': 'tr',
    'poland': 'pl', 'czech': 'cz', 'czechia': 'cz', 'hungary': 'hu', 'romania': 'ro',
    'japan': 'jp', 'china': 'cn', 'india': 'in', 'australia': 'au', 'new zealand': 'nz',
    'south korea': 'kr', 'korea': 'kr', 'thailand': 'th', 'vietnam': 'vn', 'malaysia': 'my',
    'singapore': 'sg', 'philippines': 'ph', 'indonesia': 'id', 'hong kong': 'hk',
    'brazil': 'br', 'argentina': 'ar', 'chile': 'cl', 'colombia': 'co', 'peru': 'pe',
    'south africa': 'za', 'egypt': 'eg', 'nigeria': 'ng', 'kenya': 'ke',
    'russia': 'ru', 'ukraine': 'ua', 'germany': 'de', 'israel': 'il', 'saudi arabia': 'sa',
    'uae': 'ae', 'united arab emirates': 'ae', 'dubai': 'ae',
}

function countryFlag(country) {
    if (!country) return null
    const lower = country.trim().toLowerCase()
    return lower.length === 2 ? lower : (COUNTRY_CODES[lower] || null)
}

function flagSvgUrl(country) {
    const code = countryFlag(country)
    return code ? `https://flagcdn.com/${code}.svg` : null
}

export function PlayerImageBadge({
    imageUrl,
    playerName = 'Player',
    country,
    size = 32,
    badgeSize = 18,
    onHover = null,
}) {
    const [isHovered, setIsHovered] = useState(false)
    const flagUrl = flagSvgUrl(country)

    const handleMouseEnter = () => {
        setIsHovered(true)
        onHover?.(true)
    }

    const handleMouseLeave = () => {
        setIsHovered(false)
        onHover?.(false)
    }

    return (
        <div
            style={{ position: 'relative', width: size, height: size, flexShrink: 0, backgroundColor: '#d1d5db', borderRadius: '50%' }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {/* Player Image */}
            <img
                src={imageUrl || DEFAULT_AVATAR}
                alt={playerName}
                style={{
                    width: size,
                    height: size,
                    borderRadius: '50%',
                    border: '1.5px solid var(--bnb-navy)',
                    objectFit: 'cover',
                    display: 'block',
                    filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.1))',
                    cursor: 'pointer',
                }}
                onError={e => e.currentTarget.src = DEFAULT_AVATAR}
            />

            {/* Hover Tooltip */}
            {isHovered && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: '100%',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        marginBottom: '0.4rem',
                        background: 'var(--bnb-navy)',
                        color: '#fff',
                        padding: '0.4rem 0.6rem',
                        borderRadius: '4px',
                        fontSize: '0.65rem',
                        fontWeight: 700,
                        whiteSpace: 'nowrap',
                        zIndex: 3000,
                        border: '1.5px solid var(--bnb-gold)',
                    }}
                >
                    {playerName}
                    {/* Tooltip arrow */}
                    <div
                        style={{
                            position: 'absolute',
                            top: '100%',
                            left: '50%',
                            transform: 'translateX(-50%)',
                            width: 0,
                            height: 0,
                            borderLeft: '4px solid transparent',
                            borderRight: '4px solid transparent',
                            borderTop: '4px solid var(--bnb-gold)',
                        }}
                    />
                </div>
            )}

            {/* Country Flag Badge - Bottom Right */}
            {flagUrl && (
                <div
                    style={{
                        position: 'absolute',
                        bottom: -3,
                        right: -3,
                        width: badgeSize,
                        height: badgeSize,
                        borderRadius: '50%',
                        boxShadow: '0 1px 5px rgba(0,0,0,0.28)',
                        border: '1.5px solid rgba(255,255,255,0.95)',
                        overflow: 'hidden',
                        background: '#fff',
                    }}
                >
                    <img
                        src={flagUrl}
                        alt={country}
                        style={{
                            position: 'absolute',
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            objectPosition: 'center',
                        }}
                    />
                </div>
            )}
        </div>
    )
}

export default PlayerImageBadge
